import styled from "styled-components";
import { motion } from "framer-motion";

export const HeroContainer = styled.div`
  align-items: center;
  background: linear-gradient(180deg, #545454, #000);
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 84vh;
  justify-content: space-between;
  min-height: 1000px;
  overflow: visible;
  padding: 0 40px;
  position: relative;
  user-select: none;
  width: 100%;
  z-index: 2;

  @media (max-width: 768px) {
    height: min-content;
    min-height: auto;
    padding: 120px 20px 0;
  }
`;

export const HeroWrap = styled.div`
  align-items: center;
  display: flex;
  flex: 1 0 0;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0;
  height: 1px;
  justify-content: center;
  max-width: 1400px;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 100%;
  z-index: 2;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
`;

export const TextContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 34px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 1px;

  @media (max-width: 768px) {
    align-items: center;
    width: 100%;
  }
`;

export const TitleContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 4px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    align-items: center;
    width: 100%;
  }
`;

export const BusinessTitle = styled(motion.h1)`
  font-family: "Manrope", sans-serif;
  font-size: 40px;
  font-weight: 300;
  line-height: 0.8em;
  text-align: left;
  color: rgb(221, 214, 197);
  background: linear-gradient(
    90deg,
    rgb(175, 175, 175) -7%,
    rgb(176, 176, 176) -6.45%,
    rgb(242, 249, 254) 52%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 10px;
  margin: -10px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const MainTitle = styled.h1`
  font-family: "Manrope", sans-serif;
  font-size: 80px;
  font-weight: 600;
  color: rgb(247, 96, 0);
  margin: 0;
  position: relative;
  display: inline-block;
  line-height: 1;
  width: 100%;
  white-space: nowrap;

  &::before {
    content: "";
  }

  &::after {
    content: attr(data-scrambled);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    opacity: 0;
    transition: opacity 0.1s ease;
  }

  &.animate::before {
    opacity: 0;
  }

  &.animate::after {
    opacity: 1;
  }

  @media (max-width: 768px) {
    font-size: 50px;
    content: "none";
  }
`;

export const InfoContainer = styled.div`
  border: 2px solid #ff6200;
  align-items: center;
  background-color: #191919;
  border-radius: 30px;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0;
  height: 72%;
  justify-content: flex-start;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 91%;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

export const TopWrapper = styled.div`
  align-items: center;
  box-shadow: 0 1px 2px #00000040;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 11px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 10px 16px;
  position: relative;
  width: 100%;
`;

export const BottomWrapper = styled.div`
  align-items: flex-start;
  background-color: #161616;
  border-radius: 0 0 30px 30px;
  display: flex;
  flex: none;
  flex-dircetion: row;
  flex-wrap: nowrap;
  gap: 14px;
  height: min-content;
  justify-content: flex-start;
  overflow: visible;
  padding: 20px 16px;
  position: relative;
  width: 100%;
`;

export const RaisedContainer = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 100%;
`;

export const RaisedText = styled.p`
  font-family: "Manrope", sans-serif;
  border: 1px solid #282828;
  background-color: #1c1c1c;
  border-radius: 10px;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
  height: min-content;
  justify-content: center;
  overflow: hidden;
  padding: 10px 14px;
  position: relative;
  width: auto;
  font-size: 22px;
  font-weight: 800;
  color: #fff;
  line-height: 1.5;
  text-align: center;

  span:not(.highlight) {
    font-weight: 500;
  }

  .highlight {
    color: rgb(255, 251, 0);
  }

  @media (max-width: 768px) {
    flex-direction: row;
    width: 100%;
    font-size: 18px;
    padding: 8px 12px;
    gap: 4px;
    justify-content: center;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    padding: 6px 10px;
  }
`;

export const PurchaseTitle = styled.h2`
  height: auto;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word;
  font-family: "Manrope", sans-serif;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.2;
  color: #e4e5e6;
  text-align: center;
  white-space: normal;
  padding: 0 10px;
  margin-top: 20px;

  span {
    color: rgb(255, 98, 0);
  }

  @media (max-width: 768px) {
    font-size: 20px;
    padding: 0 5px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const CountdownContainer = styled.div`
  flex: none;
  height: auto;
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  gap: clamp(0.3rem, 2vw, 1rem);
`;

export const CountdownItem = styled.div`
  text-align: center;
  padding: clamp(0.2rem, 1vw, 0.5rem);
  background-color: rgb(25, 25, 25);
  border-radius: 8px;
  min-width: clamp(35px, 8vw, 60px);
  flex: 0 1 auto;
  position: relative;
`;

export const CountdownNumber = styled(motion.div)`
  position: relative;
  height: clamp(32px, 6vw, 43.2px);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 200px;
`;

export const NumberWrapper = styled.div`
  position: absolute;
  font-size: clamp(24px, 4vw, 36px);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: #fff;
  font-weight: 700;
  backdrop-filter: blur(4px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
  transform-style: preserve-3d;
  backface-visibility: hidden;

  &.current {
    transform: translateY(0) rotateX(0deg);
    opacity: 1;
  }

  &.next {
    transform: translateY(100%) rotateX(90deg);
    opacity: 0;
  }

  &.animate {
    transform: translateY(0) rotateX(0deg);
    opacity: 1;
  }
`;

export const CountdownLabel = styled.div`
  font-size: clamp(9px, 1.5vw, 12px);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: #fff;
  text-transform: uppercase;
  margin-top: clamp(0.15rem, 0.5vw, 0.3rem);
  width: 100%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 2px;
  letter-spacing: -0.2px;
`;

export const PriceText = styled.div`
  border: 1px solid #282828;
  background-color: #1c1c1c;
  border-radius: 16px;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 4px 24px;
  position: relative;
  width: min-content;
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: rgb(228, 229, 230);
  line-height: 1.2;
  white-space: pre;
`;

export const TimeNotice = styled.div`
  flex: none;
  height: auto;
  position: relative;
  width: 100%;
`;

export const TimeProgressBar = styled.div`
  background-color: rgb(0, 0, 0);
  width: 100%;
  border-radius: 24px;
  box-shadow: rgba(29, 30, 32, 0.12) 0px 2px 4px 0px,
    rgba(29, 30, 32, 0.04) 0px 1px 2px 0px;
  opacity: 1;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 8px;
  height: 30px;
  justify-content: center;
  overflow: hidden;
  padding: 0 4px;
  position: relative;
  text-decoration: none;
  will-change: var(--framer-will-change-override, transform);
  position: relative;
`;

export const TimeNoticeText = styled.p`
  position: absolute;
  top: 50%;
  transform: translateY(-60%);
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  z-index: 1;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: rgb(234, 238, 246);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 11px;
  }

  @media (max-width: 480px) {
    font-size: 10px;
  }
`;

export const TimeProgressFill = styled.div`
  background: radial-gradient(
    150% 100% at 0% 0%,
    rgb(222, 111, 0) 0%,
    rgb(235, 91, 91) 100%
  );
  border-radius: 999999px;
  opacity: 1;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 8px;
  height: 20px;
  justify-content: center;
  overflow: visible;
  padding: 0 0px;
  position: relative;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;

  @media (max-width: 480px) {
    gap: 0.5rem;
  }
`;

export const PurchaseButton = styled.button`
  flex: 1;
  gap: 6px;
  padding: 1px 4px;
  border: 3px solid #fff;
  background-color: #000;
  border-radius: 14px;
  width: 100%;
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: min-content;
  justify-content: center;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  width: min-content;
  transition: background-color 0.3s ease-in-out;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #fff;

  &:hover {
    background-color: rgb(40, 40, 40);
  }

  @media (max-width: 480px) {
    min-width: 150px;
    padding: 0;
    font-size: 12px;
  }
`;

export const ButtonIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }

  @media (max-width: 480px) {
    width: 24px;
    height: 24px;
  }
`;

export const ImageContainer = styled.div`
  align-items: center;
  border-radius: 33px;
  display: flex;
  flex: 1 0 0;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  height: 100%;
  justify-content: center;
  overflow: visible;
  padding: 1px 0 0;
  position: relative;
  width: 1px;
  will-change: transform;
  opacity: 1;
  transform: none;

  @media (max-width: 768px) {
    width: 100%;
    height: 400px;
    flex: none;
    margin-top: 2rem;
  }

  @media (max-width: 480px) {
    height: 300px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  border-radius: inherit;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeroImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: contain;
  object-position: center;

  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const MediaContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 32px;
  height: min-content;
  justify-content: center;
  max-width: 1280px;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 1280px;
  opacity: 1;
  will-change: transform;
  transform: perspective(1200px);

  @media (max-width: 768px) {
    margin: 1rem auto;
    width: 100%;
  }
`;

export const MediaTitle = styled.h3`
  font-family: "Kodchasan", sans-serif;
  font-size: 20px;
  font-weight: 400;
  color: rgb(232, 228, 216);
  text-align: center;
  line-height: 1.3;
  letter-spacing: -0.01em;
  background: linear-gradient(
    24deg,
    rgb(255, 255, 247) 0%,
    rgba(255, 255, 247, 0.34) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 0 10px rgba(255, 255, 247, 0.2);
`;

export const LogoSlider = styled.div`
  height: 100px;
  position: relative;
  width: 100%;
  display: flex;
  max-width: 100%;
  place-items: center;
  margin: 0;
  padding: 10px;
  opacity: 1;
  mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgb(0, 0, 0) 15%,
    rgb(0, 0, 0) 85%,
    rgba(0, 0, 0, 0) 100%
  );
  overflow: hidden;
`;

export const LogoContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  place-items: center;
  margin: 0;
  padding: 0;
  gap: 80px;
  position: relative;
  flex-direction: row;
  will-change: transform;
  animation: slide 25s linear infinite;

  @media (max-width: 768px) {
    gap: 40px;
    animation: slide 5s linear infinite;
  }

  @keyframes slide {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(calc(-33.33% - 80px));
    }
  }
`;

export const LogoImage = styled.img`
  height: 32px;
  width: auto;
  opacity: 0.8;
  transition: all 0.3s ease;
  filter: grayscale(100%) brightness(1.5);

  @media (max-width: 768px) {
    height: 30px;
  }
`;

export const BackgroundOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  opacity: 0.37;

  &::before {
    content: "";
    background: url("https://framerusercontent.com/images/rR6HYXBrMmX4cRpXfXUOvpvpB0.png");
    background-size: 256px 256px;
    background-repeat: repeat;
    opacity: 0.08;
    inset: -200%;
    width: 400%;
    height: 400%;
    position: absolute;
    will-change: transform;
  }
`;

export const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled(motion.div)`
  background-color: rgb(25, 25, 25);
  border-radius: 16px;
  padding: 2rem;
  width: 90%;
  max-width: 500px;
  position: relative;
  border: 2px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 480px) {
    padding: 1.5rem;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    transform: rotate(90deg);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ModalTitle = styled.h3`
  font-family: "Manrope", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 1.5rem;
  text-align: center;
`;

export const InputGroup = styled.div`
  margin-bottom: 1.5rem;
`;

export const InputLabel = styled.label`
  display: block;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  color: #fff;
  margin-bottom: 0.5rem;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.8rem;
  background-color: rgb(35, 35, 35);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #fff;
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: rgb(255, 98, 0);
    box-shadow: 0 0 0 2px rgba(255, 98, 0, 0.2);
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 1rem;
  background-color: rgb(255, 98, 0);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgb(255, 120, 0);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SuccessMessage = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgb(25, 25, 25);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
`;

export const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgba(0, 255, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;

  svg {
    width: 40px;
    height: 40px;
    color: #00ff00;
  }
`;

export const SuccessText = styled.h3`
  font-family: "Manrope", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 1rem;
`;

export const SuccessDescription = styled.p`
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 2rem;
`;

export const ErrorMessage = styled.div`
  background-color: rgba(255, 0, 0, 0.1);
  border: 1px solid rgba(255, 0, 0, 0.2);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  color: #ff0000;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const PriceInfo = styled.div`
  background-color: rgb(35, 35, 35);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  color: #fff;

  &.total {
    font-size: 18px;
    font-weight: 600;
    color: rgb(255, 98, 0);
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
`;

export const PaymentMethod = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const PaymentOption = styled.button`
  flex: 1;
  padding: 1rem;
  background-color: ${(props) =>
    props.active ? "rgb(35, 35, 35)" : "transparent"};
  border: 1px solid
    ${(props) =>
      props.active ? "rgb(255, 98, 0)" : "rgba(255, 255, 255, 0.1)"};
  border-radius: 8px;
  color: #fff;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    background-color: rgb(35, 35, 35);
    border-color: rgb(255, 98, 0);
  }
`;
